module.exports = __webpack_public_path__ + "src/assets/icon_credit.svg";